import React, { Component } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import Icon from '../../../../Shared/Icon'
import { withTranslation } from 'react-i18next'
import PaymentLinkCreator from '../../Invoices/PaymentLinkCreator'
import { invoiceStatus } from '../../../../../constants'
import { Col, Row } from '../../../../Shared/Grid'
import { adminGetInvoices } from '../../../../../api'
import InvoiceBill from './InvoiceBill'

class Invoices extends Component {

  constructor (props) {
    super(props)
    this.state = {
      collapseAll: true,
      showAdditionalInvoiceInfo: {},
      invoices: [],
      loading: false,
      error: null,
    }
    this.abortController = new AbortController()
  }

  componentDidMount () {
    this.loadInvoices()
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.orderId !== prevProps.orderId) {
      this.loadInvoices()
    }
  }

  loadInvoices = () => {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null }, () => {
      adminGetInvoices(this.props.orderId, this.abortController).fetchPromise.then((response) => {
        this.setState({ loading: false, invoices: response })
      }).catch(() => {
        this.setState({ loading: false, error: 'Failed to get invoices' })
      })
    })
  }

  collapse (collapse) {
    if (collapse) {
      this.setState({
        collapsedAll: collapse,
        showAdditionalInvoiceInfo: {}
      })
    } else {
      let showAdditionalInvoiceInfo = {}
      for (const invoice of this.state.invoices) {
        showAdditionalInvoiceInfo[invoice.id] = 1
      }
      this.setState({
        collapsedAll: collapse,
        showAdditionalInvoiceInfo: showAdditionalInvoiceInfo
      })
    }
  }

  toggleInvoiceInformation = (id) => {
    let showAdditionalInvoiceInfo = { ...this.state.showAdditionalInvoiceInfo }
    if (showAdditionalInvoiceInfo.hasOwnProperty(id)) {
      delete showAdditionalInvoiceInfo[id]
    } else {
      showAdditionalInvoiceInfo[id] = 1
    }
    this.setState({
      showAdditionalInvoiceInfo: showAdditionalInvoiceInfo
    })
  }

  createResultRow (invoice) {
    const { t } = this.props
    const showAdditionalInformation = this.state.showAdditionalInvoiceInfo.hasOwnProperty(invoice.id)

    return (
      <React.Fragment key={invoice.id}>
        <tr onClick={() => {this.toggleInvoiceInformation(invoice.id)}}>
          <td data-title={'ID'}>{invoice.id}</td>
          <td
            data-title={t('PERIOD_FROM')}>{invoice.periodFrom ? dayjs(invoice.periodFrom).locale(this.props.i18n.language).format('L') : '-'}</td>
          <td
            data-title={t('PERIOD_TO')}>{invoice.periodTo ? dayjs(invoice.periodTo).locale(this.props.i18n.language).format('L') : '-'}</td>
          <td
            data-title={t('CREATED_AT')}>{invoice.createdAt ? dayjs(invoice.createdAt).locale(this.props.i18n.language).format('L LT') : '-'}</td>
          <td
            data-title={t('MODIFIED_AT')}>{invoice.modifiedAt ? dayjs(invoice.modifiedAt).locale(this.props.i18n.language).format('L LT') : '-'}</td>
          <td
            data-title={t('STATUS')}>{this.getStatus(invoice.status)}
            {invoice.status === invoiceStatus.statusFailed || invoice.status === invoiceStatus.statusPaymentLinkSent ?
              <PaymentLinkCreator invoiceId={invoice.id} onPaymentLinkCreated={this.loadInvoices}/> : null}
          </td>
          <td>
            <span className={'clearfix'} style={{ float: 'right', display: 'flex', alignItems: 'flex-end' }}>
            <span style={{ marginLeft: '5px' }} onClick={() => {this.toggleInvoiceInformation(invoice.id)}}><Icon
              type={showAdditionalInformation ? 'arrow-blue-up' : 'arrow-blue-dn'}/></span>
            </span>
          </td>
        </tr>
        {showAdditionalInformation ?
          <tr>
            <td colSpan={7}>
              <InvoiceBill invoiceId={invoice.id} orderItems={this.props.orderItems}/>
            </td>
          </tr>
          : null}
      </React.Fragment>
    )
  }

  getStatus (status) {
    switch (status) {
      case invoiceStatus.statusPaymentLinkSent:
        return this.props.t('INVOICE_STATUS_PAYMENT_LINK_SENT')
      case invoiceStatus.statusOutstanding:
        return this.props.t('INVOICE_STATUS_OUTSTANDING')
      case invoiceStatus.statusPaymentInitiated:
        return this.props.t('INVOICE_STATUS_PAYMENT_INITIATED')
      case invoiceStatus.statusPaid:
        return this.props.t('INVOICE_STATUS_PAID')
      case invoiceStatus.statusFailed:
        return this.props.t('INVOICE_STATUS_FAILED')
      case invoiceStatus.statusInvalidAmountPaid:
        return this.props.t('INVOICE_STATUS_INVALID_AMOUNT_PAID')
      default:
        return '-'
    }
  }

  render () {
    const { t } = this.props
    return (
      <Row>
        <Col xs={12}>
          <h3>{t('INVOICE', { count: 2 })}</h3>
        </Col>
        <Col xs={12}>
          <div className="flex-table" style={{ flex: 1 }}>
            <div style={{ position: 'relative' }} className="table-responsive-vertical">
              <table className="table table-hover table-mc-light-blue Gradient">
                <thead>
                <tr>
                  <td>ID</td>
                  <td>{t('PERIOD_FROM')}</td>
                  <td>{t('PERIOD_TO')}</td>
                  <td>{t('CREATED_AT')}</td>
                  <td>{t('MODIFIED_AT')}</td>
                  <td>{t('STATUS')}</td>
                  <td/>
                </tr>
                </thead>
                <tbody>
                {this.state.invoices.map((item) => this.createResultRow(item))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    )
  }
}

Invoices.propTypes = {
  orderId: PropTypes.number.isRequired,
  orderItems: PropTypes.object // where Key = itemId
}
export default withTranslation()(Invoices)
